import React, { useState, useEffect } from "react";
import "./Event.css";
import Footer from "../Footer";

const Event = () => {
  const [showNotification, setShowNotification] = useState(false);

  // Example: Toggle notification visibility every 5 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setShowNotification((prev) => !prev); // Toggle the notification
    }, 5000); // Change interval as needed (e.g., 5 seconds)

    return () => clearInterval(interval); // Cleanup on component unmount
  }, []);

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh", // Ensures the parent container spans the full viewport height
      }}
    >
      {/* Main content */}
      <div className="event-container" >
        <h2>Event Notifications</h2>
        {/* Blinking Notification */}
        {showNotification && (
          <div className="blinking-notification">
            New Event Alert! 🚨
          </div>
        )}
        {/* Event List */}
        <div className="event-list">
          <p>Event 1: Meeting at 10:00 AM</p>
          <p>Event 2: Workshop at 3:00 PM</p>
          {/* Add more events as needed */}
        </div>
      </div>

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default Event;
